import { actionToMethod } from '../constants/mappings';

class APIMapper {
  perform(change) {
    const methodToCall = actionToMethod.get(change.item.actionType);
    return this[methodToCall](change);
  }
}

export default APIMapper;
